// @flow
import { createSelector } from "reselect"
import type { InputSelector } from "reselect"

import keys from "../consts/headerDataKeys"
import translateSelector from "../services/intl/translateSelector"
import type Options from "../records/Options"

type State = {
  options: Options,
  // eslint-disable-next-line flowtype/no-weak-types
  page: any, // FIXME proper type
  // eslint-disable-next-line flowtype/no-weak-types
  translations: any, // FIXME make proper definitions and import 'em here
}

const getPage = state => state.page.get("name") // FIXME make selector in the appropriate file
const optionsSelector = state => state.options

export const getTitle: InputSelector<State, *, string> = createSelector(
  [translateSelector, getPage],
  (translate, page) => {
    if (keys[page]) {
      return translate(keys[page].title)
    }

    return translate("common.easy_booking_with_skypicker")
  },
)

export const getKeywords: InputSelector<State, *, string> = createSelector(
  [translateSelector, getPage],
  (translate, page) => {
    if (keys[page] && keys[page].keywords) {
      return translate(keys[page].keywords)
    }

    return translate("common.easy_booking_with_skypicker")
  },
)

export const getDescription: InputSelector<State, *, string> = createSelector(
  [translateSelector, getPage],
  (translate, page) => {
    if (keys[page]) {
      return translate(keys[page].description, { oldBrand: "Skypicker" })
    }

    return translate("common.easy_booking_with_skypicker")
  },
)

export const getImageOG: InputSelector<State, *, ?string> = createSelector(
  [getPage],
  page => keys[page] && keys[page].image_og,
)

export const getImageTwitter: InputSelector<State, *, ?string> = createSelector(
  [getPage],
  page => keys[page] && keys[page].image_twitter,
)

export const getSocialUrlPath: InputSelector<State, *, ?string> = createSelector(
  [getPage, optionsSelector],
  (page, options) => {
    if (keys[page] && keys[page].social_url_path) {
      return keys[page].social_url_path.replace("{lang}", options.get("language"))
    }

    return null
  },
)
